module.exports = __webpack_public_path__ + "static/media/employee-appreciation-hero.981e2068.jpg";